import { axiosInstance } from "./axiosConfig";
import { isAxiosError } from "axios";

// INTERFACE_MEDICAL_REQUEST_ITEM
interface MedicalRequestItem {
    [key: string]: {
        key: string;
        value: string | number | null;
    };
}

// INTERFACE_MEDICAL_SERVICE_CATEGORY
interface MedicalServiceCategory {
    key: string;
    value: MedicalRequestItem[] | MedicalRequestItem;
}

// INTERFACE_MEDICAL_REQUEST_SECTION
interface MedicalRequestSection {
    key: string;
    value: MedicalServiceCategory[];
}

// INTERFACE_SUCCESS_RESPONSE
interface MedicalRequestsSuccessResponse {
    data: MedicalRequestSection[];
    message?: string;
}

// VALIDATION_ERROR
interface ErrorDetail {
    code: string;
    detail: string;
    attr: string;
}

// GENERIC_ERROR_RESPONSE
interface GenericErrorResponse {
    error?: string;
}

// INTERFACE_ERROR_RESPONSE
interface MedicalRequestsErrorResponse {
    type: 'validation_error';
    errors: ErrorDetail[];
}

// INTERFACE_RESULT
interface MedicalRequestsResult {
    data: MedicalRequestsSuccessResponse | MedicalRequestsErrorResponse | GenericErrorResponse;
    status: number;
}

// GET MEDICAL REQUESTS API
export const GetMedicalRequests = async (
    language: 'az' | 'en' = 'az'
): Promise<MedicalRequestsResult> => {
    try {
        const response = await axiosInstance.get<MedicalRequestsSuccessResponse>(
            '/health/medical-requests',
            {
                headers: {
                    'Accept-Language': language,
                }
            }
        );

        return {
            data: response.data,
            status: response.status
        };

    } catch (error) {
        if (isAxiosError(error)) {
            // HTTP ERROR
            if (error.response) {
                return {
                    data: error.response.data || { error: 'Bilinməyən xəta baş verdi' },
                    status: error.response.status
                };
            }

            // Network error
            if (error.request) {
                return {
                    data: { error: 'Şəbəkə xətası - cavab alınmadı' },
                    status: 0
                };
            }
        }

        // Another error
        return {
            data: {
                error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
            },
            status: -1
        };
    }
};